<script setup>
const propsHeader = defineProps({
  menuHeader: {
    type: String,
    default: '',
  },
});

defineExpose({
  propsHeader,
});
</script>
<template>
  <li class="navigation-header mb-1 mt-2">
    <span>{{ propsHeader.menuHeader }}</span>
  </li>
</template>
